import {useDispatch, useSelector} from "react-redux";
import {cloneDeep} from "lodash";
import InputComponent from "../../../components/input.component";
import React from "react";
import {setBeautyFridayBannerDetail} from "../../../reducers/beauty-friday.reducer";

const ItemBanner = ({fieldList, index}) => {
    const dispatch = useDispatch()
    const {bannerDetail, beautyFridayErrorMessage} = useSelector(state => state.beautyFridayReducer)

    const onChangeInput = (key, value) => {
        const copyItemList = cloneDeep(bannerDetail.item_list)
        copyItemList[index][key] = value
        dispatch(setBeautyFridayBannerDetail({item_list: copyItemList}))
    }

    return (
        <div className={"grid grid-cols-2 gap-x-16 gap-y-4"}>
            {fieldList.map((item, i) => (
                <InputComponent key={i} item={item} data={bannerDetail?.item_list?.[index]?.[item.key]} error={beautyFridayErrorMessage[`item_list[${index}]`] ?? {}} onChange={onChangeInput} onChangeInput={onChangeInput}/>
            ))}
        </div>
    )
}

export default ItemBanner